import styled from '@emotion/styled';
export const FormContainer = styled.main`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 3.2rem;
	max-width: 44rem;
	width: 100%;
	margin: 0 auto;
	@media screen and (max-width: 442px) {
		padding: 0 2rem;
	}
`;
export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	align-items: center;
`;

export const ImgBox = styled.div`
	width: 11.8rem;
	img {
		width: 100%;
	}
`;
export const Title = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	strong {
		color: #47a3f3;
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	}
`;
export const NextButton = styled.button`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	background-color: ${(props) => props.theme.colors.primary400};
	color: #fff;
	height: 4.4rem;
	padding: 0 1.2rem;
	border: none;
	cursor: pointer;
	&:disabled {
		background-color: #e9ecef;
		color: #adb5bd;
	}
`;
